import StoreHelper from '../../../store/helper'
import PositionManager from '../../PositionManager'
import EventBus, { Events } from '../../../event-bus'

import _ from 'lodash'
import { DraggablePlaceholder } from '../index'

export const onDrop = (e) => {
  const dropTargetPositionIndex = PositionManager.getPositionConsideringPagination(StoreHelper.getDropTargetIndex(e.target, true))

  StoreHelper.removeDragElement(StoreHelper.getActiveViewKey(), DraggablePlaceholder)
  StoreHelper.addDragElement(StoreHelper.getActiveViewKey(), StoreHelper.getDragElement(), dropTargetPositionIndex)

  if (!_.isEqual(StoreHelper.getDragStartIndex(), dropTargetPositionIndex)) {
    EventBus.$emit(Events.B_MENU_ITEM_ORDER_CHANGED, StoreHelper.getDraggingElementValue(), dropTargetPositionIndex)
  }

  PositionManager.recalculateDropTargetPositions()
}
